import React from "react";
import PropTypes from "prop-types";

const ModalStateContext = React.createContext();

const ModalStateProvider = ({ children }) => (
    <ModalStateContext.Provider value>{children}</ModalStateContext.Provider>
);

ModalStateProvider.propTypes = {
    children: PropTypes.node.isRequired,
};

export default ModalStateContext;
export { ModalStateProvider };
